/**
 * La guarda de movimiento reducido del confeti del aviso de novedades (goal
 * portal-correcciones 10).
 *
 * 🚨 No es cosmética: es la diferencia entre una celebración y un mareo. Quien
 * pidió menos movimiento en su sistema operativo recibe el aviso igual —el
 * contenido es el mismo—, solo que sin partículas cayéndole por encima.
 */
export const CONSULTA_MENOS_MOVIMIENTO = '(prefers-reduced-motion: reduce)'

/**
 * ¿Esta persona pidió menos movimiento?
 *
 * 🚨 `window.matchMedia` PUEDE NO EXISTIR y hay que guardarlo: en el jsdom con
 * el que corre la suite de este repo es `undefined` (medido), así que un
 * `window.matchMedia(...)` a pelo no devolvería `false`: tumbaría el render del
 * aviso entero con un TypeError. La misma guarda cubre cualquier entorno sin
 * CSSOM.
 *
 * El default es `false` —«sí puede haber movimiento»— a propósito: no poder
 * preguntar no es lo mismo que haber pedido menos movimiento.
 */
export function prefiereMenosMovimiento(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return false
  }
  try {
    return window.matchMedia(CONSULTA_MENOS_MOVIMIENTO).matches
  } catch {
    // Un matchMedia presente pero roto (navegadores embebidos raros) no puede
    // impedir que salga el aviso.
    return false
  }
}
